// "Assinar pelo site" — link externo, SEMPRE ao lado da compra pela loja.
//
// iOS (Brasil): StoreKit External Purchase (entitlement
//   com.apple.developer.storekit.custom-purchase-link.allowed-regions = ["br"],
//   iPhone com iOS 26.5+). O plugin nativo ExternalPurchase checa a
//   elegibilidade, mostra a folha de aviso do SISTEMA, pega o token e abre o
//   navegador. O token vai para o servidor (a Apple exige reportar TODOS, com
//   ou sem venda). Ver ios/App/App/ExternalPurchasePlugin.swift.
// Android: o programa de ofertas externas do Google ainda não existe para o
//   Brasil (set/2026). A ponte fica pronta: sem o plugin nativo instalado, o
//   botão simplesmente não aparece.
//
// Tudo atrás de LINK_EXTERNO_IOS / LINK_EXTERNO_ANDROID (padrão false).

import { Capacitor, registerPlugin } from '@capacitor/core';
import { callFirebaseFunction } from '../../utils/firebaseFunctionCaller';
import { registrarMetrica } from './anunciosApi';

const ExternalPurchase = registerPlugin('ExternalPurchase');

function flagDaPlataforma(cfg) {
  const p = Capacitor.getPlatform();
  if (p === 'ios') return cfg?.LINK_EXTERNO_IOS === true;
  if (p === 'android') return cfg?.LINK_EXTERNO_ANDROID === true;
  return false;
}

/**
 * @param {object} cfg config pública de anúncios
 * @return {{ativo:boolean, onAbrir:()=>Promise<{aberto:boolean, motivo?:string}>}}
 */
export function estadoLinkExterno(cfg) {
  const ativo = Capacitor.isNativePlatform()
    && flagDaPlataforma(cfg)
    && Capacitor.isPluginAvailable('ExternalPurchase');
  return {
    ativo,
    onAbrir: async () => {
      if (!ativo) return { aberto: false, motivo: 'INDISPONIVEL' };
      const plataforma = Capacitor.getPlatform();
      const base = cfg?.LINK_EXTERNO_URL || 'https://www.lesvita.com/assinar';
      const url = `${base}${base.includes('?') ? '&' : '?'}origem=app_${plataforma}`;
      try {
        const r = await ExternalPurchase.abrir({ url });
        if (r?.token) {
          callFirebaseFunction('registrarTokenCompraExterna', {
            token: String(r.token),
            tipo: r.tipo || null,
            plataforma,
          }).catch(() => {});
        }
        if (r?.aberto) registrarMetrica('LINK_EXTERNO_ABERTO');
        return { aberto: !!r?.aberto, motivo: r?.motivo };
      } catch {
        return { aberto: false, motivo: 'ERRO' };
      }
    },
  };
}
